export default __webpack_public_path__ + "static/media/mobile.920361b6.png";